import React, { useEffect, useState, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import {Avatar, Button, Col, Drawer, Row} from 'antd';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons';
import * as Setting from '../utils/AuthUtils';
import { DescriptionItem } from '../utils/ComponentUtils';
import { MeContext } from '../context/';

function UserInfoMenu() {
    const [visible, setVisible] = useState(false);
    const [userInfo, setUserInfo] = useState(null);
    const me = useContext(MeContext);
    const location = useLocation();

    useEffect(() => {
        Setting.getUserinfo()
        .then(
          (result) => {
            setUserInfo(result.payLoad);
          },
          (error) => {
            // console.warn(error);
          }
        )
    }, [me])

    function toggleDrawer() {
        if (visible) {
            setVisible(false)
        } else {
            setVisible(true)
        }
    }
    
    function toLogout() {
        Setting.logout();
        setUserInfo(null);
        setVisible(false);
        window.location.reload(false);
        // navigate('/web/login', { replace: true });
    }

    function toLogin(event) {
        event.preventDefault();
        const prevUrl = location.pathname;
        // console.warn('saving previous url:', prevUrl)
        localStorage.setItem('prevUrl', prevUrl);
        Setting.goToLink(Setting.getSigninUrl());
      }

    // const user = Setting.getUserinfo();
    // console.warn('stato utente:', me)

    if (me && me.payLoad && me.errorMsg === "") {
        return (
            (<div>
                <div onClick={toggleDrawer}><Avatar style={{ backgroundColor: '#3a8cde' }} src={userInfo ? userInfo.avatar : ''} icon={<UserOutlined />} /></div>
                <Drawer placement="right" onClose={toggleDrawer} open={visible} bodyStyle={{ textAlign: 'center' }}>
                    <Avatar rootstyle={{ backgroundColor: '#3a8cde' }} src={userInfo ? userInfo.avatar : ''} icon={<UserOutlined />} size={{ xs: 24, sm: 32, md: 80, lg: 100, xl: 120, xxl: 180 }} />
                    <p className="site-description-item-profile-p">Profilo Utente</p>
                    <Row>
                        <Col span={24}>
                            <DescriptionItem title="Nome" content={userInfo ? userInfo.displayName : '' } />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>
                            <DescriptionItem title="Email" content={userInfo ? userInfo.email : '' } />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>
                            <DescriptionItem title="Ruolo" content={userInfo ? userInfo.type : '' } />
                        </Col>
                    </Row>
                    <Row justify="center">
                        <Col> 
                            <Button type="primary" onClick={toLogout} icon={<LogoutOutlined />}>Log Out</Button>
                        </Col>
                    </Row>
                </Drawer>
            </div>)
        );
    }

    return (
        <div>
        <div onClick={toggleDrawer}><Avatar style={{ backgroundColor: '#3a8cde' }} icon={<UserOutlined />} /></div>
        <Drawer placement="right" onClose={toggleDrawer} open={visible} bodyStyle={{ textAlign: 'center' }}>
            <Avatar rootstyle={{ backgroundColor: '#3a8cde' }} icon={<UserOutlined />} size={{ xs: 24, sm: 32, md: 80, lg: 100, xl: 120, xxl: 180 }} />
            <p className="site-description-item-profile-p">Profilo Utente</p>
            <Row>
                <Col span={12}>
                    <DescriptionItem title="Nome" content="Non Disponibile" />
                </Col>
                <Col span={12}>
                    <DescriptionItem title="Cognome" content="Non disponibile" />
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <DescriptionItem title="Email" content="Non disponibile" />
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <DescriptionItem title="Ruolo" content="Ospite" />
                </Col>
            </Row>
            <Row justify="center">
                <Col>
                    <Button type="primary" onClick={toLogin} icon={<LogoutOutlined />}>Log In</Button>
                </Col>
            </Row>
        </Drawer>
    </div>
    )
}

export default UserInfoMenu;